
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceFreelancerReason,
  FreelancerComplianceBlockingStatus,
  ValidationError,
} from '../models';
import {
    ComplianceFreelancerReasonFromJSON,
    ComplianceFreelancerReasonToJSON,
    FreelancerComplianceBlockingStatusFromJSON,
    FreelancerComplianceBlockingStatusToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface BlockComplianceForFreelancerRequest {
    freelancerCompanyId: string;
    complianceFreelancerReason: ComplianceFreelancerReason;
}

export interface GetFreelancerComplianceBlockingStatusRequest {
    freelancerCompanyId: string;
}

export interface UnblockComplianceForFreelancerRequest {
    freelancerCompanyId: string;
    complianceFreelancerReason: ComplianceFreelancerReason;
}

/**
 * 
 */
export class FreelancerComplianceBlockingApi extends runtime.BaseAPI {

    /**
          */
    async blockComplianceForFreelancerRaw(requestParameters: BlockComplianceForFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling blockComplianceForFreelancer().'
            );
        }

        if (requestParameters['complianceFreelancerReason'] == null) {
            throw new runtime.RequiredError(
                'complianceFreelancerReason',
                'Required parameter "complianceFreelancerReason" was null or undefined when calling blockComplianceForFreelancer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/freelancer/{freelancerCompanyId}/compliance/block`.replace(`{${"freelancerCompanyId"}}`, encodeURIComponent(String(requestParameters['freelancerCompanyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComplianceFreelancerReasonToJSON(requestParameters['complianceFreelancerReason']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async blockComplianceForFreelancer(requestParameters: BlockComplianceForFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.blockComplianceForFreelancerRaw(requestParameters, initOverrides);
    }

    /**
          */
    async getFreelancerComplianceBlockingStatusRaw(requestParameters: GetFreelancerComplianceBlockingStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerComplianceBlockingStatus>> {
        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getFreelancerComplianceBlockingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerComplianceBlockingStatus>({
            path: `/compliance/api/freelancer/{freelancerCompanyId}/compliance/blocking-status`.replace(`{${"freelancerCompanyId"}}`, encodeURIComponent(String(requestParameters['freelancerCompanyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerComplianceBlockingStatusFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFreelancerComplianceBlockingStatus(requestParameters: GetFreelancerComplianceBlockingStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerComplianceBlockingStatus> {
        const response = await this.getFreelancerComplianceBlockingStatusRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async unblockComplianceForFreelancerRaw(requestParameters: UnblockComplianceForFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling unblockComplianceForFreelancer().'
            );
        }

        if (requestParameters['complianceFreelancerReason'] == null) {
            throw new runtime.RequiredError(
                'complianceFreelancerReason',
                'Required parameter "complianceFreelancerReason" was null or undefined when calling unblockComplianceForFreelancer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/freelancer/{freelancerCompanyId}/compliance/unblock`.replace(`{${"freelancerCompanyId"}}`, encodeURIComponent(String(requestParameters['freelancerCompanyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComplianceFreelancerReasonToJSON(requestParameters['complianceFreelancerReason']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async unblockComplianceForFreelancer(requestParameters: UnblockComplianceForFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.unblockComplianceForFreelancerRaw(requestParameters, initOverrides);
    }

}
